module.exports = function() {
  return new Worker(__webpack_public_path__ + "1a700eddfc7d0f89cc6b.worker.js");
};


//////////////////
// WEBPACK FOOTER
// ./~/worker-loader/dist/cjs.js!./src/services/templateWorker.js
// module id = 2651
// module chunks = 1